module.exports = __webpack_public_path__ + "img/guide.d4425744.jpg";